import { SignalRService } from "src/app/services/signalr.service";
import { ApiService } from "src/app/services/api.service";
import { Component, OnInit } from "@angular/core";
import { EgxData } from "src/app/models/egx-data";
import { Observable, timer } from "rxjs";
import { map } from 'rxjs/operators';
@Component({
  selector: "app-home-market-summary",
  templateUrl: "./home-market-summary.component.html",
  styleUrls: ["./home-market-summary.component.scss"],
})
export class HomeMarketSummaryComponent implements OnInit {
  egxData: EgxData;
  egxIndex = 0;
  totalCalc: number;
  isMarketActive: boolean;
  nowDate: Date;
  nowTime$: Observable<Date> = timer(0, 1000).pipe(map(() => new Date()));
  lang: string = localStorage.getItem('lang') || 'en';

  constructor(private _service: ApiService, signalR: SignalRService) {
    signalR.summaryChanges.subscribe((res) => {
      this.egxData = res as EgxData;
      this.totalCalc =
        this.egxData.UNCHANGED +
        this.egxData.ADVANCING +
        this.egxData.DECLINING;
    });

    signalR.marketStatusChanges.subscribe((res) => {
      this.isMarketActive = res;
    });

    this.fetchMarketSummary();
    this.fetchMarketStatus();
  }

  selectedEgx = ["EGX30", "EGX70", "EGX100"];

  fetchMarketSummary() {
    this._service.fetchMarketSummary().subscribe((res) => {
      this.egxData = res as EgxData;
      this.totalCalc =
        this.egxData.UNCHANGED +
        this.egxData.ADVANCING +
        this.egxData.DECLINING;
    });
  }

  fetchMarketStatus() {
    this._service.fetchMarketStatus().subscribe((res) => {
      if (res.length > 0) {
        this.isMarketActive = true;
      }
      this.nowDate = new Date();
    });
  }

  setEgx(number) {
    this.egxIndex = number;
  }

  ngOnInit(): void {}
}
